export default __webpack_public_path__ + "static/media/ss.d6b57fec.svg";